import script from "./DefaultDeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultDeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./DefaultDeleteDialog.vue?vue&type=style&index=0&id=d129ab80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d129ab80"]])

export default __exports__